import React, { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import {
  CommonOrCommonRetirementFlug,
  FormKbn,
  Prefectures,
  YesOrNoFlug,
  applyEvent,
  formClassCorp,
  formClassFacility,
} from "../../assets/data/Constants";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkTable from "../../components/atoms/TkTable";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkButton from "../../components/atoms/TkButton";
import TkMemo from "../../components/molecules/TkMemo";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { TkGetCode } from "../../utils/TkGetCode";
import { IAPI_CON002_Request, IAPI_APP016_Request } from "../../type/apiType";
import { httpIAPI_CON002, httpIAPI_APP016 } from "./api/request";
import {
  schema,
  fakeTableList,
  headTitleList,
  headTitleList2,
  formMap,
} from "./parts";
import "./_style.scss";
import _ from "lodash";
import { isStatusAfterApproval } from "../../utils/useTools";

/**
 * SCRW070001 申請情報詳細（新規契約）
 * @returns JSX.Element
 */
const SCRW070001 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state;
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const [status, setStatus] = useState<any>();
  const [bodyListData, setBodyListData] = useState();
  const [bodyList, setBodyList] = useState<any>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [responseData, setResponseData] = useState<any>({});
  const [memoBodyList, setMemoBodyList] = useState([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  const handleInfoBtnClick = (item: any) => {
    navigate("/SCRW070002", {
      state: {
        applyId: locationState?.applyId
          ? locationState?.applyId
          : businessState?.job_01?.applyId,
        contractorNo: businessState.common?.contractorNo,
        contractorName: businessState.common?.contractorName,
        facilityKind: item.facilityKind,
        facilityNo: item.facilityNo,
        facilityName: item.facilityName,
      },
    });
  };

  const handleInit = async () => {
    const applyIdData: IAPI_CON002_Request = {
      applyId: locationState?.applyId
        ? locationState?.applyId
        : businessState.job_01?.applyId!,
    };
    // 共済契約申請書参照API呼び出し
    try {
      const res = await httpIAPI_CON002({
        ...applyIdData,
      });

      if (res.resultCd === "I0000") {
        setResponseData(res);
        setStatus(res.latestApplyStatus);

        let resArr = stateFakeTableList.current;
        setBusinessState({
          ...businessState,
          job_01: {
            applyId: res.applyId,
          },
        });

        // 初期表示
        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;

          targetObj && (targetObj.setDefaultValue = res[i as keyof typeof res]);
          targetObj && (targetObj.text = res[i as keyof typeof res]);
        }

        resArr.find((item) => item.keyword === "contractorName")!.text =
          (businessState.common?.contractorNo ?? "") +
          ":" +
          (businessState.common?.contractorName ?? "");

        resArr.find((item) => item.keyword === "businessOwnerClass")!.text =
          res.businessOwnerClass;

        resArr.find((item) => item.keyword === "address")!.text =
          (TkGetCode(Prefectures, res.prefectureCd) ?? "") +
          (res.addressCity ?? "") +
          (res.addressOthers ?? "");

        resArr.find((item) => item.keyword === "typeOffacilityOperated")!.text =
          res.mainFacilityKinds;

        resArr.find(
          (item) => item.keyword === "pastContractCancelDate"
        )!.showLine = res.pastContractFlg === YesOrNoFlug["有"];

        const historyCertificateFile = res.formList?.find(
          (item) =>
            item.formKbn === FormKbn["法人書類"] &&
            item.formClass === formClassCorp["履歴事項全部証明書（写）"]
        );
        if (historyCertificateFile) {
          let historyCertificate = resArr.find(
            (item) => item.keyword === "historyCertificate"
          )!;

          historyCertificate.dataname = historyCertificateFile.fileName;
          historyCertificate.base64filedata = historyCertificateFile.fileBase64;

          historyCertificate.showLine = true;
        }

        const employmentRulesFile = res.formList?.find(
          (item) =>
            item.formKbn === FormKbn["法人書類"] &&
            item.formClass === formClassCorp["就業規則"]
        );

        if (employmentRulesFile) {
          let employmentRules = resArr.find(
            (item) => item.keyword === "employmentRules"
          )!;

          employmentRules.dataname = employmentRulesFile.fileName;
          employmentRules.base64filedata = employmentRulesFile.fileBase64;

          employmentRules.showLine = true;
        }

        const salaryRulesFile = res.formList?.find(
          (item) =>
            item.formKbn === FormKbn["法人書類"] &&
            item.formClass === formClassCorp["給与規程"]
        );
        if (salaryRulesFile) {
          let salaryRules = resArr.find(
            (item) => item.keyword === "salaryRules"
          )!;

          salaryRules.dataname = salaryRulesFile.fileName;
          salaryRules.base64filedata = salaryRulesFile.fileBase64;

          salaryRules.showLine = true;
        }

        setStatecorpInfoList(resArr);

        const listData: any = res.facilityList?.map((item: any) => {
          let documentaryEvidence = res.formList?.find(
            (file) =>
              file.formKbn === FormKbn["施設書類"] &&
              file.formClass ===
                formClassFacility["当該施設・事業を経営している証拠書類"] &&
              file.facilityNo === item.facilityNo
          );

          return [
            {
              children: item.facilityKind,
            },
            {
              children: item.facilityNo + ":" + item.facilityName,
            },
            {
              children: documentaryEvidence ? (
                <TkDownloadLink
                  dataname={documentaryEvidence.fileName ?? ""}
                  base64filedata={documentaryEvidence.fileBase64 ?? ""}
                  downloadBase64
                />
              ) : null,
            },
            {
              children: (
                <Box className="infoBtn">
                  <TkButton onClick={() => handleInfoBtnClick(item)}>
                    職員情報参照
                  </TkButton>
                </Box>
              ),
            },
          ];
        });
        setBodyListData(listData);

        const dataMemo: any = res.statusList?.map((item: any) => [
          {
            children: item.managerName,
          },
          {
            children: item.process,
          },
          {
            children: item.createDate,
            align: "center",
          },
          {
            children: item.processComment,
          },
        ]);
        setMemoBodyList(dataMemo);

        let showLine = isStatusAfterApproval(res.latestApplyStatus);
        const bodyData = [
          [
            {
              children: (
                <Box className="link">
                  {formMap.map((item, index) => {
                    let file = res.formList?.find(
                      (i) => item.formClass === i.formClass
                    );

                    if (!file) return null;

                    return (
                      <React.Fragment key={index}>
                        <TkDownloadLink
                          downloadBase64
                          base64filedata={file?.fileBase64!}
                          dataname={item.formName}
                        />
                      </React.Fragment>
                    );
                  })}
                </Box>
              ),
              width: "50%",
            },
            {
              children: showLine && res.symbolNo,
              verticalAlign: "top",
            },
            {
              children: showLine && res.decisionDate,
              verticalAlign: "top",
            },
          ],
        ];

        setBodyList(bodyData);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  const makeHttpObj = (num: any, formData?: any): IAPI_APP016_Request => {
    let reqObj: IAPI_APP016_Request = {
      applyId: responseData?.applyId,
      applyEvent: num,
      contractorNo: businessState.common?.contractorNo,
      symbolNo: formData
        ? TkGetCode(CommonOrCommonRetirementFlug, formData?.symbolNumberType) +
          "第" +
          formData?.symbolNumber +
          "号"
        : "",
      decisionDate: formData?.settlementDate,
      conclusionDate: formData?.contractConclusionDate,
      inquiryCode: memoCheck ? "1" : "",
      screenId: "SCRW070001",
      reason: memoData,
      dueDate: formData?.paymentDeadline,
    };

    return reqObj;
  };

  const handleCallApi = async (num?: any, formData?: any) => {
    // 申請状況更新API呼び出し
    let reqData: IAPI_APP016_Request = makeHttpObj(num ?? "3", formData);
    try {
      const res = await httpIAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        navigate("/SCRW110001");

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setIsOpen(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const btnEvent = async (btnName: keyof typeof applyEvent) => {
    let applyEventCd = applyEvent[btnName];

    switch (applyEventCd) {
      case applyEvent["受理"]:
      case applyEvent["契約者に差戻し"]:
      case applyEvent["拒絶"]:
      case applyEvent["課長代理確認"]:
      case applyEvent["担当者に差戻し"]:
      case applyEvent["課長代理拒絶確認"]:
      case applyEvent["上長承認"]:
      case applyEvent["郵送"]:
        handleCallApi(applyEventCd);
        break;
      case applyEvent["承認"]:
        setIsOpen(true);
        break;
      default:
        return;
    }
  };

  return (
    <Box className="SCRW070001" data-testid="SCRW070001PageForTest">
      <TkKikoStepper
        applicationFlowType="TYPE1"
        businessType="JOB-01"
        corporateApplicationClassification={responseData?.corpApplyKbn}
        applicationStatus={status}
      />

      <TkFakeTable
        list={statecorpInfoList}
        ruleSchema={schema}
        showButton={false}
      />

      <Box className="info">施設情報</Box>
      <TkTable headList={headTitleList} bodyList={bodyListData} />

      <TkMemo bodyList={memoBodyList} onChange={onChange} />

      <TkTableWithNoLine headList={headTitleList2} bodyList={bodyList} />

      <Box className="btns">
        <TkBackButton className="backBtn" />
        <TkViewButtonJudgement
          flowType={"TYPE1"}
          Status={status}
          onClick={btnEvent}
        />
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        data-testid="SCRW070001PageForDialog"
        JobType="JOB-01"
        open={isOpen}
        displayOnlyPaymentDeadline
        onSuccess={(e: any) => handleCallApi(undefined, e)}
        onClose={() => setIsOpen(false)}
      />
    </Box>
  );
};

export default SCRW070001;
